import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadList: -1,
    loadDetails: -1,
    sendToPatient: -1,
    updating: -1,
  },
  records: [],
  details: {},
  query: {
    search: '',
    status: '1',
    abnormal: '-',
    currentPage: 1,
    pageSize: 15,
  },
  extras: {
    currentPage: 0,
    pageSize: 15,
    total: 0,
  },
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.LAB_RESULTS_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 0,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 1,
        },
        records: payload.result.data,
        extras: {
          ...state.extras,
          total: payload.result.pagination.total,
          currentPage: payload.result.pagination.page,
          pageSize: 15,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 2,
        },
        error,
      };
    case ACTION_TYPES.LAB_RESULTS_DETAILS_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDetails: 0,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_DETAILS_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDetails: 1,
        },
        details: payload.result.data,
      };
    case ACTION_TYPES.LAB_RESULTS_DETAILS_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDetails: 2,
        },
        error,
      };
    case ACTION_TYPES.LAB_RESULTS_SEND_TO_PATIENT_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          sendToPatient: 0,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_SEND_TO_PATIENT_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          sendToPatient: 1,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_SEND_TO_PATIENT_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          sendToPatient: 2,
        },
        error,
      };
    case ACTION_TYPES.LAB_RESULTS_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 0,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 1,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 2,
        },
        error,
      };
    case ACTION_TYPES.LAB_RESULTS_FILTER_CHANGE_ABNORMAL:
      return {
        ...state,
        query: {
          ...state.query,
          abnormal: payload,
          currentPage: 1,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_FILTER_CHANGE_STATUS:
      return {
        ...state,
        query: {
          ...state.query,
          status: payload,
          currentPage: 1,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_PAGE_CHANGE:
      return {
        ...state,
        query: {
          ...state.query,
          currentPage: payload,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_SEARCH_CHANGE:
      return {
        ...state,
        query: {
          ...state.query,
          search: payload,
          currentPage: 1,
        },
      };
    default:
      return state;
  }
}
